export enum PaymentMethodType {
    Card = 0,
    BankAccount = 1,
    PayPal = 2,
    BitPay = 3,
    Credit = 4,
    WireTransfer = 5,
    AppleInApp = 6,
    GoogleInApp = 7,
    Check = 8,
}
